import { z } from "zod";

export const RequestHelperGetPartnerPrepopInfoOutputSchema = z.object({
    clientEmail: z.string().nullish(),
});

export type RequestHelperGetPartnerPrepopInfoOutput = z.infer<typeof RequestHelperGetPartnerPrepopInfoOutputSchema>;